export default __webpack_public_path__ + "8aa832049d4b206c97012fb8d261068b.svg";